var path = 'views/validators/edit/PdfAValidator.html';
var html = "<div class=form-group> </div> <ng-include src=\"'views/validators/edit/validationErrorMessage.html'\"></ng-include> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;